import React from 'react';
import { motion } from 'framer-motion';
export function TruthSection() {
  return <section className="py-14 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-287">
      {/* Distinctive background for this section */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0f1d36] to-[#0a1628] -z-10" data-id="element-288" />
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#d4af37]/30 to-transparent" data-id="element-289" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#d4af37]/30 to-transparent" data-id="element-290" />

      <div className="max-w-4xl mx-auto" data-id="element-291">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-292">
          <h2 className="text-3xl md:text-4xl font-bold text-white font-heading mb-4 tracking-wider" data-id="element-293">
            LA VERDAD QUE NADIE TE DICE
          </h2>
          <div className="w-24 h-1 bg-gold-gradient mx-auto rounded-full" data-id="element-294" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-8 text-center" data-id="element-295">
          <p className="text-xl md:text-2xl text-white font-medium" data-id="element-296">
            El problema no es que seas mal/a AT.
          </p>
          <p className="text-xl md:text-2xl text-white font-medium" data-id="element-297">
            El problema es que trabajás sin un sistema de documentación
            profesional.
          </p>

          <div className="bg-[#0a1628]/80 border border-[#d4af37]/30 rounded-2xl p-8 md:p-10 my-10 gold-glow relative" data-id="element-298">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#0a1628] px-4 text-[#d4af37] font-bold tracking-widest text-sm" data-id="element-299">
              EL DATO REAL
            </div>
            <p className="text-2xl md:text-3xl text-white font-heading leading-relaxed" data-id="element-300">
              El <span className="text-gold-gradient font-bold" data-id="element-301">80%</span> de
              los informes rechazados por las Obras Sociales son rechazados por
              errores de redacción, formato y estructura.
            </p>
          </div>

          <div className="space-y-4 text-lg md:text-xl text-[#e2e8f0] font-light" data-id="element-302">
            <p data-id="element-303">No son errores clínicos complejos.</p>
            <p data-id="element-304">Son errores que se podían evitar.</p>
            <p data-id="element-305">La Obra Social no te avisa.</p>
            <p data-id="element-306">Te deja presentar.</p>
            <p data-id="element-307">Y después llega el rechazo.</p>
          </div>

          <div className="pt-8 mt-8 border-t border-[#1a2b4c]" data-id="element-308">
            <p className="text-xl md:text-2xl text-[#a0aec0] mb-2" data-id="element-309">
              La solución no es trabajar más horas.
            </p>
            <p className="text-2xl md:text-3xl text-white font-bold" data-id="element-310">
              La solución es tener un{' '}
              <span className="text-gold-gradient" data-id="element-311">
                sistema de redacción blindada
              </span>
              .
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}